import { isIOS } from 'react-device-detect';

export const getStoreUrlByOS = () => {
  const appStore = 'https://apps.apple.com/br/app/digi-igu%C3%A1/id1588069396';
  const playStore =
    'https://play.google.com/store/apps/details?id=com.iguaapp&hl=pt_BR&gl=US';
  return isIOS ? appStore : playStore;
};
